// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 3.79V2M11 3.79V2M4 3.79H12C13.1 3.79 14 4.69 14 5.79V6.3M4 3.79C2.9 3.79 2 4.69 2 5.79V12C2 13.1 2.9 14 4 14H6.7',
  'M4 3.79C2.9 3.79 2 4.69 2 5.8V6.17C2 6.72 2.45 7.17 3 7.17H7.2',
  'M13.4 10.7C13.4 12.11 12.26 13.25 10.85 13.25C9.44 13.25 8.3 12.11 8.3 10.7C8.3 9.29 9.44 8.15 10.85 8.15C12.26 8.15 13.4 9.29 13.4 10.7Z',
  'M12.65 12.5L14.4 14.25',
];
